const configs = {
    // Env
    stage: process.env.NODE_ENV || 'development',

    // basename: only at build time to set, and Don't add '/' at end off BASENAME for breadcrumbs, also Don't put only '/' use blank('') instead,
    // like '/berry-material-react/react/default'
    basename: '/',
    defaultPath: false,
    baseRoute: window.BASE_ROUTE || process.env.REACT_APP_BASE_ROUTE || '',
    host: process.env.REACT_APP_HOST_DOMAIN || '',
    adminPath: '',

    // LINE
    OALink: process.env.REACT_APP_LINE_AT_URL || '',
    OA_URI: process.env.REACT_APP_LINE_AT_URL || '',
    liffId: process.env.REACT_APP_LIFF_ID || '',
    enableProfilePlus: false,

    // TP
    shopId: process.env.REACT_APP_SHOP_ID || '',

    // SMS verify
    smsCode: '0000',
    phoneExpireTime: 15 * 60 * 1000,

    // GA
    gaTrackId: process.env.REACT_APP_TRACKING_ID || '',
    gaCategory: process.env.REACT_APP_GA_CATEGORY || '',

    // Customization
    fontFamily: `'Poppins', 'Roboto', sans-serif`,
    borderRadius: 4,
    gridSpacing: 3,
    drawerWidth: 260,
    appDrawerWidth: 320,

    // Page
    wallpaper: {
        background: 'https://dak6ovdfbyw15.cloudfront.net/img/5/ap-wallpaper-collection/wallpaper-collection-bg.jpg',
        logo: {
            img: '',
            width: '',
            height: ''
        },
        displayNamePrefix: '',
        displayNameSuffix: '',
        title: ''
    },
    menu: [
        {
            action: '',
            type: '',
            img: ''
        }
    ],
    downLoadPage: {
        background: '',
        intructionText: ''
    }
};

console.log('configs:', configs);

export default configs;
